import { createFileRoute } from '@tanstack/react-router';

interface ResetConfirmSearch {
  token?: string;
}

export const Route = createFileRoute('/auth/password-reset-confirm')({
  validateSearch: (search: Record<string, unknown>): ResetConfirmSearch => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
});
